import React from "react";
import Autosuggest from "react-autosuggest";

const Carrier = ({
  index,
  valueState,
  suggestions,
  setSuggestions,
  isSelectSuggestion,
  changeInput,
  airlineDetails,
}) => {
  // const escapeRegexCharacters = (str) => {
  //   return str.replace(/[.*+?^${}()|[]]/g, "$&");
  // };

  // const getSuggestions = (value) => {
  //   const escapedValue = escapeRegexCharacters(value.trim());
  //   if (escapedValue === "") {
  //     return [];
  //   }
  //   const regex = new RegExp(`^${escapedValue}`, "i");
  //     return airlineDetails.filter((carrier) => regex.test(carrier.label));

  // };
  const getSuggestions = (value) => {
    const filterResult = airlineDetails.filter((item) =>
      item.label.toLowerCase().includes(value.trim().toLowerCase())
    );
    return filterResult;
  };
  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionSelected = (event, { suggestionValue }) => {
    isSelectSuggestion(suggestionValue);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = (suggestion) => {
    return suggestion;
  };

  const renderSuggestion = (suggestion) => {
    return <div> {suggestion.label} </div>;
  };

  const renderInputComponent = (props) => (
    <input {...props} className="form-control" required />
  );

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={true}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder: "Carrier",
        value: valueState[index].label,
        onChange: (e) => changeInput(e.target.value, index),
        id: `flightLegs.return[${index}].flightCarrierId`,
        name: `flightLegs.return[${index}].flightCarrierId`,
      }}
      renderInputComponent={renderInputComponent}
    />
  );
};

export default Carrier;
